// import dayjs from "dayjs";
import { planningToolApiUrls } from "../../configs/planningToolApiUrls";
import basicRequest from "../basicRequest";

export const permissionsService = {
    getPermissions: async () => {
        const request = new basicRequest();  
        return await request.get(planningToolApiUrls.authorizationGrant);
    }
}